import { formatMoney } from 'lib/functions/utils';

import { TableEntry } from './types';

export const EXCEL_COLUMN_MAP = {
  ENTRY_ID: 'ID Asiento',
  ENTRY_NAME: 'Glosa Asiento',
  DATE: 'Fecha',
  CLASS: 'Clase',
  TYPE: 'Tipo',
  STATUS: 'Pendiente',
  NODE_KEY: 'Cuenta',
  DEBIT: 'Debe',
  CREDIT: 'Haber',
  DOCUMENT_KEY: 'Numero Docto.',
  BUSINESS_IDENTIFIER: 'RUT',
  COST_CENTER: 'Centro costo',
  DESCRIPTION: 'Glosa Linea',
} as const;

export const VALIDATION_CONFIG = {
  BALANCE_TOLERANCE: 0.01,
  EXCEL_EPOCH_YEAR: 1899,
  EXCEL_EPOCH_MONTH: 11,
  EXCEL_EPOCH_DAY: 30,
  MILLISECONDS_PER_DAY: 86400000,
  EXCEL_HEADER_ROW_OFFSET: 2,
  DEFAULT_ENTRY_TYPE: 'free',
  DEFAULT_ENTRY_STATUS: 'CLOSED',
  UTC_HOURS_FOR_API: 12,
} as const;

export const ERROR_MESSAGES = {
  FILE_FORMAT_NOT_SUPPORTED:
    'Formato de archivo no soportado. Solo .xlsx y .xls',
  NO_VALID_ENTRIES: 'No se encontraron asientos válidos en el archivo',
  FILE_PROCESSING_ERROR: 'Error al procesar el archivo',
  NO_ENTRIES_SELECTED: 'Debes seleccionar al menos un asiento',
  IMPORT_ERROR: 'Error al importar los asientos contables',
  ENTRY_NAME_REQUIRED: 'El nombre del asiento es requerido',
  DATE_REQUIRED: 'La fecha es requerida',
  DATE_INVALID: 'La fecha no es válida',
  DATE_NOT_IN_PERIOD: 'La fecha no está dentro de ningún período contable',
  PERIOD_CLOSED: (periodLabel: string) =>
    `El período contable "${periodLabel}" está cerrado para esta fecha`,
  NO_LINES: 'El asiento debe tener al menos una línea',
  DEBITS_CREDITS_NOT_EQUAL: (diff: number) =>
    `El asiento esta desbalanceado en ${formatMoney(diff)}`,
  NODE_NOT_FOUND: (lineNumber: number, nodeKey: string) =>
    `Línea ${lineNumber}: No se encontró la cuenta contable "${nodeKey}". Verifica que la cuenta existe en el sistema.`,
  NODE_INVALID: (lineNumber: number) =>
    `Línea ${lineNumber}: La cuenta contable no es válida`,
  COST_CENTER_REQUIRED: (lineNumber: number, nodeKey: string) =>
    `Línea ${lineNumber}: El centro de costo es requerido para la cuenta "${nodeKey}"`,
  BUSINESS_IDENTIFIER_REQUIRED: (lineNumber: number, nodeKey: string) =>
    `Línea ${lineNumber}: El RUT es requerido para la cuenta "${nodeKey}"`,
  ZERO_DEBIT_CREDIT: (lineNumber: number) =>
    `Línea ${lineNumber}: El débito y crédito no pueden ser ambos cero`,
  NEGATIVE_VALUES: (lineNumber: number) =>
    `Línea ${lineNumber}: Los valores de débito y crédito no pueden ser negativos`,
  BUSINESS_NOT_FOUND: (ruts: string[]) =>
    `Las siguientes empresas no existen: ${ruts.join(', ')}. Por favor, crea las empresas antes de importar los asientos.`,
} as const;

export const SUCCESS_MESSAGES = {
  ENTRIES_FOUND: (count: number) => `Se encontraron ${count} asientos válidos`,
  ENTRIES_IMPORTED: (count: number) =>
    `Se importaron ${count} asientos correctamente`,
} as const;

export const VALID_ENTRIES_HEADERS: Array<{
  key: keyof TableEntry;
  label: string;
  type: string;
}> = [
  { key: 'name', label: 'Nombre', type: 'text' },
  { key: 'date', label: 'Fecha', type: 'date' },
  { key: 'linesCount', label: 'Líneas', type: 'text' },
  { key: 'totalDebit', label: 'Total Débito', type: 'money' },
  { key: 'totalCredit', label: 'Total Crédito', type: 'money' },
];

export const INVALID_ENTRIES_HEADERS: Array<{
  key: keyof TableEntry;
  label: string;
  type: string;
}> = [
  { key: 'name', label: 'Nombre', type: 'text' },
  { key: 'date', label: 'Fecha', type: 'date' },
  { key: 'linesCount', label: 'Líneas', type: 'text' },
  { key: 'errors', label: 'Errores', type: 'text' },
];

export const EXCEL_TEMPLATE = [
  {
    [EXCEL_COLUMN_MAP.ENTRY_ID]: '1',
    [EXCEL_COLUMN_MAP.ENTRY_NAME]: 'Asiento de ejemplo',
    [EXCEL_COLUMN_MAP.CLASS]: 'Egreso',
    [EXCEL_COLUMN_MAP.DATE]: '2025-11-15',
    [EXCEL_COLUMN_MAP.NODE_KEY]: '11041001',
    [EXCEL_COLUMN_MAP.DEBIT]: '100000',
    [EXCEL_COLUMN_MAP.CREDIT]: '0',
    [EXCEL_COLUMN_MAP.DOCUMENT_KEY]: '123',
    [EXCEL_COLUMN_MAP.BUSINESS_IDENTIFIER]: '12345678-9',
    [EXCEL_COLUMN_MAP.DESCRIPTION]: 'Descripción de la línea 1',
  },
  {
    [EXCEL_COLUMN_MAP.ENTRY_ID]: '1',
    [EXCEL_COLUMN_MAP.ENTRY_NAME]: 'Asiento de ejemplo',
    [EXCEL_COLUMN_MAP.CLASS]: 'Ingreso',
    [EXCEL_COLUMN_MAP.DATE]: '2025-11-15',
    [EXCEL_COLUMN_MAP.NODE_KEY]: '21076010',
    [EXCEL_COLUMN_MAP.DEBIT]: '0',
    [EXCEL_COLUMN_MAP.CREDIT]: '100000',
    [EXCEL_COLUMN_MAP.DOCUMENT_KEY]: '123',
    [EXCEL_COLUMN_MAP.BUSINESS_IDENTIFIER]: '12345678-9',
    [EXCEL_COLUMN_MAP.DESCRIPTION]: 'Descripción de la línea 2',
  },
];
